@if (holdedData(); as data) {
  <div class="holded-configured-details">
    <div class="summary-row" role="group" aria-label="Estado de configuración Holded">
      <div
        class="field-chip"
        matTooltip="Identificador de contacto de la empresa en Holded, verificado contra la API."
        matTooltipPosition="above"
      >
        <span class="field-chip-label">Empresa</span>
        <span
          class="field-chip-status"
          [class.field-chip-status--ok]="companyFieldStatus() === HoldedFieldStatusEnum.Configured"
          [class.field-chip-status--warn]="companyFieldStatus() === HoldedFieldStatusEnum.Invalid"
          [class.field-chip-status--ko]="companyFieldStatus() === HoldedFieldStatusEnum.Pending"
        >
          {{ HoldedFieldStatusLabels[companyFieldStatus()] }}
        </span>
        @if (data.company_holded_id) {
          <span class="field-chip-value">{{ data.company_holded_id }}</span>
        }
      </div>

      <div
        class="field-chip"
        matTooltip="Cuenta contable de ingresos del producto en Holded, verificada contra el plan contable."
        matTooltipPosition="above"
      >
        <span class="field-chip-label">Producto</span>
        <span
          class="field-chip-status"
          [class.field-chip-status--ok]="companyProductFieldStatus() === HoldedFieldStatusEnum.Configured"
          [class.field-chip-status--warn]="companyProductFieldStatus() === HoldedFieldStatusEnum.Invalid"
          [class.field-chip-status--ko]="companyProductFieldStatus() === HoldedFieldStatusEnum.Pending"
        >
          {{ HoldedFieldStatusLabels[companyProductFieldStatus()] }}
        </span>
        @if (data.company_product_holded_accounting_account_id) {
          <span class="field-chip-value">{{ data.company_product_holded_accounting_account_id }}</span>
        }
      </div>
    </div>
  </div>
}
